import { computed } from '@vue/composition-api';
import Test from '@/orm/models/Test/Test';

export default function useTest() {
  function getTestInfoByVacancy(vacancyId) {
    return computed(
      () => Test.query()
        .withAllRecursive()
        .where('vacancyId', vacancyId)
        .first(),
    );
  }

  async function deleteAll() {
    await Test.deleteAll();
  }

  async function createTest(id, payload) {
    await Test.api().createTest(id, payload);
  }

  async function updateTest(id, testId, payload) {
    await Test.api().updateTest(id, testId, payload);
  }

  async function publishTest(id, testId) {
    await Test.api().publishTest(id, testId);
  }

  async function unpublishTest(id) {
    await Test.api().unpublishTest(id);
  }

  async function removeTest(id, testId) {
    await Test.api().removeTest(id, testId);
  }

  async function getTestInfo(id) {
    await deleteAll();
    await Test.api().getTestInfo(id);
  }

  async function getRedactingTestInfo(id) {
    await deleteAll();
    await Test.api().getRedactingTestInfo(id);
  }

  async function createRedactingTestInfo(vacancyId, testId) {
    await deleteAll();
    await Test.api().createRedactingTest(vacancyId, testId);
  }

  return {
    createTest,
    publishTest,
    unpublishTest,
    removeTest,
    updateTest,
    getTestInfo,
    getRedactingTestInfo,
    createRedactingTestInfo,
    getTestInfoByVacancy,
    deleteAll,
  };
}
